import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { InvoiceRevenueReport } from "@/pages/auswertungen/InvoiceRevenueReport";

export function InvoiceRevenuePage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["invoice-revenue"]}
    >
      <InvoiceRevenueReport />
    </AppShell>
  );
}
